import {
    ExportAssertionFraudResult,
    FormattedExportAssertionFraudResult
} from "@idw-types/data/export-assertion-fraud-result";
import { Assertion, RelyingParty, RiskLevel } from "@idw-types/data/reference-data/generic";
import { RpServiceConfiguration } from "@idw-types/data/rp-service-configuration";

export const formatExportAssertionFraudResults = (
    exportAssertionFraudResults: Array<ExportAssertionFraudResult>,
    assertions: Array<Assertion>,
    relyingParties: Array<RelyingParty>,
    riskLevels: Array<RiskLevel>,
    rpServices: Array<RpServiceConfiguration>
): Array<FormattedExportAssertionFraudResult> => {
    return exportAssertionFraudResults.map(result => formatExportAssertionFraudResult(
        result,
        assertions,
        relyingParties,
        riskLevels,
        rpServices
    ));
};

export const formatExportAssertionFraudResult = (
    exportAssertionFraudResult: ExportAssertionFraudResult,
    assertions: Array<Assertion>,
    relyingParties: Array<RelyingParty>,
    riskLevels: Array<RiskLevel>,
    rpServices: Array<RpServiceConfiguration>
): FormattedExportAssertionFraudResult => {
    const assertion = assertions.find(a => +a.id === exportAssertionFraudResult.assertionID);
    const relyingParty = relyingParties.find(rp => +rp.id === exportAssertionFraudResult.relyingPartyID);
    const riskLevel = riskLevels.find(rl => +rl.id === exportAssertionFraudResult.riskLevelID);
    const rpService = rpServices.find(rps => +rps.id === exportAssertionFraudResult.rpAXNServiceID);

    let date = null;
    if (exportAssertionFraudResult.date) {
        date = new Date(exportAssertionFraudResult.date);
    }

    return {
        asi: exportAssertionFraudResult.asi,
        credential: exportAssertionFraudResult.credential,
        date: date,
        mbun: exportAssertionFraudResult.mbun,
        relyingParty: relyingParty,
        rpAXNService: rpService,
        assertion: assertion,
        claimStatus: exportAssertionFraudResult.claimStatus,
        finalPolicyDecision: exportAssertionFraudResult.finalPolicyDecision,
        riskLevel: riskLevel
    };
};